/**
 * ============================================================================
 * TEMPLATES STORE - CACHE RETRIEVAL BY GAME
 * ============================================================================
 * 
 * Functions for retrieving cached templates filtered by game ID.
 * 
 * These functions read from the local cache and don't trigger API calls.
 * Call fetchTemplates() first to ensure the cache is populated.
 * 
 * @module templates/cache/byGame
 */

import { templatesStore } from "../store";
import type { GlossaryBlueprint } from "@/types-games";

// ============================================================================
// CACHE RETRIEVAL BY GAME
// ============================================================================

/**
 * Get cached templates for a specific game.
 * 
 * Note: This reads from local cache. Call fetchTemplates() first to populate the cache.
 * 
 * @param gameId - The game ID to filter by
 * @returns Array of cached templates for the game
 * 
 * @example
 * ```ts
 * const templates = getCachedTemplates(gameId);
 * ```
 */
export function getCachedTemplates(gameId: string): GlossaryBlueprint[] {
  const allTemplates = templatesStore.getData();
  return allTemplates.filter(template => template.game_id === gameId);
}
